import { IMessagePageContent, IResponse } from "../../services/interface/data";

export const updateMessage = (currentData: IResponse | undefined, messagePageContentPart: IMessagePageContent): IResponse => {
    const dataPageContentIndex = currentData?.page_content?.findIndex(
        (entry) =>
            entry.component_id === messagePageContentPart.component_id
    );

    const updatePart = currentData?.page_content?.reduce((current, entry, index) => {
        if (index === dataPageContentIndex){
            return [
                ...current,
                {
                    ...messagePageContentPart,
                }
            ];
        }
        return [...current, entry]
    }, [] as any);
    const newData = {
        ...currentData,
        page_content: updatePart,
    } as IResponse;

    return newData;
};